export enum CountryCode {
  US = 'US',
  MX = 'MX',
  CA = 'CA',
  AU = 'AU',
  ZA = 'ZA',
  BR = 'BR',
  KZ = 'KZ',
  FR = 'FR',
  DE = 'DE',
  GB = 'GB',
  IE = 'IE',
}

export enum CallingCode {
  US = '+1',
  MX = '+52',
  CA = '+1',
  AU = '+61',
  ZA = '+27',
  BR = '+55',
  KZ = '+7',
  FR = '+33',
  DE = '+49',
  GB = '+44',
  IE = '+353',
}

export interface Phone {
  countryCode: CountryCode;
  callingCode: CallingCode;
  phoneNumber: string;
}
